import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d2bc3f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "download-link" }
const _hoisted_2 = {
  class: "download-link__icon download-link__icon--left",
  "aria-hidden": "true"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "download-link__title"
}
const _hoisted_5 = {
  key: 1,
  class: "download-link__meta"
}
const _hoisted_6 = { class: "download-link__filetype" }
const _hoisted_7 = {
  class: "download-link__icon download-link__icon--right",
  "aria-hidden": "true"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "download-link__spinner download-link__spinner--right" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "spinner",
    viewBox: "0 0 50 50"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      class: "spinner__path",
      cx: "25",
      cy: "25",
      r: "20",
      fill: "none",
      "stroke-width": "4"
    })
  ])
], -1))

import { getIconComponent } from '../icons/utils';
import { Download } from '@/types/download';

interface Props {
	download: Download;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadLink',
  props: {
    download: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getIconComponent)('specs'))))
    ]),
    (_ctx.download.url)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "download-link__link",
          href: _ctx.download.url
        }, [
          (_ctx.download.title)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.download.title), 1))
            : _createCommentVNode("", true),
          (_ctx.download.filetype || _ctx.download.filesize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.download.filetype) + " " + _toDisplayString(_ctx.download.filesize), 1)
              ]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_7, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getIconComponent)('download'))))
    ]),
    _hoisted_8
  ]))
}
}

})